// extracted by mini-css-extract-plugin
module.exports = {"gardeniaContainer":"style_gardeniaContainer__aMmEq"};